import React, { useEffect, useState } from 'react';
import { getWorkoutHistory } from './firebaseUtils';

function WorkoutHistory() {
  const [history, setHistory] = useState([]);

  useEffect(() => {
    const fetchHistory = async () => {
      const data = await getWorkoutHistory();
      setHistory(data);
    };
    fetchHistory();
  }, []);

  return (
    <div style={{ marginTop: '30px' }}>
      <h3>🗂️ Workout History</h3>
      {history.length === 0 ? (
        <p>No workouts logged yet.</p>
      ) : (
        <ul style={{ listStyle: 'none', padding: 0 }}>
          {history.map((item, index) => (
            <li
              key={index}
              style={{
                padding: '10px',
                marginBottom: '8px',
                backgroundColor: '#f9f9f9',
                borderLeft: '4px solid #4CAF50',
                borderRadius: '4px'
              }}
            >
              <strong>{item.deckType?.toUpperCase()} deck</strong> —{' '}
              {item.completedAt?.toDate().toLocaleDateString(undefined, {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default WorkoutHistory;
